export default {
    title: `<i class="fa fa-lg fa-check-square"></i> 중간점검`,
    datas: [
        // { type: "oxquiz",
        //     content: "도커 이미지는 여러개의 컨테이너를 만들 수 있다.",
        //     ans: true
        // },
        // { type: "oxquiz",
        //     content: "컨테이너로 이미지를 만들 수 있다.",
        //     ans: true,
        // },
        // { type: "quiz",
        //     content: "다음 도커 명령어 중 이미지를 생성하는 명령어는?",
        //     questions: [
        //         "docker make image", 
        //         "docker build",
        //         "docker create",
        //     ],
        //     answers: [1],
        // },
        // { type: "quiz",
        //     content: "다음 Dockerfile 명령어 중 포트를 설정하는 명령어는?",
        //     questions: [
        //         "PORT", 
        //         "PORTS",
        //         "EXTERNAL",
        //         "EXPOSE",
        //     ],
        //     answers: [3],
        // },
        // { type: "quiz",
        //     content: "다음 Dockerfile 명령어 중 올바른 것은? (정답 여러개)",
        //     questions: [
        //         "CMD : 이미지 생성시 수행할 셀 명령어나 스크립트를 지정합니다.", // 0 
        //         "WORKDIR : 외부(호스트)와 연결할 디렉토리를 설정합니다.",
        //         "FROM : 기본 이미지(base image)를 설정합니다.",
        //         "COPY : 외부(호스트)의 파일/디렉토리를 컨테이너 내부로 복사합니다.",
        //         "ENTRYPOINT : 외부(호스트)와 연결할 포트를 설정합니다.",
        //         "ENV : 컨테이너 내부의 환경 변수를 설정합니다.",
        //     ],
        //     answers: [2,3,5],
        // },

        
        { type: "next",
            content: "다음",
            url: "/sections/05"
        },
    ]
}